import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { TextInput, Flex, Label, Popup } from '@leverege/ui-elements'
import { Section, LabelGroup } from '~/views'
import BaseAttributeEditor from './BaseAttributeEditor'
import { UpdaterSelector, UpdaterFactory } from '~/editors/updaters'

import S from './style.css'

class ResourceEnumAttributeEditor extends React.Component {

  static propTypes = {
    attribute : PropTypes.object,
    blueprint : PropTypes.object,
    onChange : PropTypes.func.isRequired
  }

  constructor( props ) {
    super( props )
    this.state = {
      enums : null
    }
    this.changePath = BaseAttributeEditor.ChangePath.bind( this )
    this.onUpdaterChange = BaseAttributeEditor.OnUpdaterChange.bind( this )
    this.onSelectUpdater = this.onSelectUpdater.bind( this )
  }

  componentDidMount() {
    const { dispatch, blueprint } = this.props
    dispatch( async ( dispatch, getState, { api } ) => {
      try {
        const enums = await api.project( blueprint.projectId ).resourceEnums().list()
        this.setState( { enums } )
      } catch ( err ) {
        console.log( 'failed to load resource enums', err )
      }
    } )
  }

  onSetEnum = ( { data } ) => {
    this.changePath( 'enumType', data )
  }

  onSelectUpdater( updater ) {
    this.changePath( 'sim/updater', updater, false )
  }

  getEnumValues( enums ) {
    if ( !enums ) return null

    const values = Object.values( enums ).map( rsrcEnum => (
      <Popup.Item
        key={rsrcEnum.type}
        eventData={rsrcEnum.type}
        onClick={this.onSetEnum}>
        {rsrcEnum.name}
      </Popup.Item>
    ) )

    values.unshift(
      <Popup.Item
        key="null"
        eventData={null}
        onClick={this.onSetEnum}>
        Clear (set to null)
      </Popup.Item>
    )
    return values
  }

  render() {
    const { attribute : attr, blueprint } = this.props
    const { enums } = this.state
    if ( attr == null ) {
      return <div />
    }
    const uProps = { attribute : attr, blueprint, onChange : this.onUpdaterChange }
    const updater = UpdaterFactory.createEditor( attr.sim && attr.sim.updater, uProps )

    return (
      <div>
        <BaseAttributeEditor {...this.props} />
        <Section header="Resource Enum Options">
          <Flex className={S.pad} variant="colM" direction="column" align="stretch">
            <LabelGroup>
              <Label>Enum Type</Label>
              <Popup
                title={attr?.enumType || 'Set Enum Value'}>
                {enums?.items?.map( rsrcEnum => (
                  <Popup.Item
                    key={rsrcEnum.type}
                    eventData={rsrcEnum.type}
                    onClick={this.onSetEnum}>
                    {rsrcEnum.name}
                  </Popup.Item>
                ) )}
              </Popup>
            </LabelGroup>
            {/* <LabelGroup>
              <Label>Rsrc Type</Label>
              <TextInput
                disabled
                hint="Resource Type..." 
                value={attr?.resourceType}
                onChange={( { value } ) => this.changePath( 'enumType', value )} />
            </LabelGroup> */}
          </Flex>
        </Section>
        <Section header="Simulation">
          <Flex className={S.pad} variant="colM" direction="column" align="stretch">
            <LabelGroup>
              <Label>Initial Value</Label>
              <TextInput
                hint="Initial Value..." 
                value={attr?.sim?.initialValue}
                onChange={( { value } ) => this.changePath( 'sim/initialValue', value )} />
            </LabelGroup>
            {
              UpdaterSelector.hasCreators( attr ) && 
              (
                <LabelGroup>
                  <Label>Update With</Label>
                  <UpdaterSelector attribute={attr} updater={attr?.sim?.updater} onSelect={this.onSelectUpdater} />
                </LabelGroup>
              )
            }
            {updater}
          </Flex>
        </Section>
      </div>
    ) 
  }
}

export default connect()( ResourceEnumAttributeEditor )
